(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nutcars-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nutcars-tabs')) {
  customElements.define('nutcars-tabs', class extends HTMLElement {
    connectedCallback() {
      const tabs = this.querySelectorAll('.nc-tabs__tab');
      const panels = this.querySelectorAll('.nc-tabs__panel');
      const panelContainer = this.querySelector('.nc-tabs__panels');

      // Lock the panel container to the tallest panel's height so switching
      // tabs doesn't resize the page and jump the scroll position.
      const lockHeight = () => {
        if (!panelContainer) return;
        panelContainer.style.minHeight = '';
        let max = 0;
        panels.forEach(p => {
          const wasHidden = p.hasAttribute('hidden');
          if (wasHidden) p.removeAttribute('hidden');
          const h = p.offsetHeight;
          if (h > max) max = h;
          if (wasHidden) p.setAttribute('hidden', '');
        });
        if (max > 0) panelContainer.style.minHeight = max + 'px';
      };

      // Recompute after fonts/images settle.
      requestAnimationFrame(lockHeight);
      window.addEventListener('load', lockHeight, { once: true });
      window.addEventListener('resize', lockHeight);

      tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const scrollY = window.scrollY;
          const idx = tab.getAttribute('data-index');
          tabs.forEach(t => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
          panels.forEach(p => {
            if (p.getAttribute('data-index') === idx) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
          this.setAttribute('data-active', idx);
          // Restore scroll if the browser or focus moved it.
          if (Math.abs(window.scrollY - scrollY) > 1) {
            window.scrollTo({ top: scrollY, behavior: 'instant' });
          }
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
